import { all } from 'async-saga';
import janus from './janus';
import script from './script';

export default all(
  janus,
  script,
)
